<template>
  <ButtonSquare
    :title="$t('general__view__satellite')"
    :imgSource="iconSatellite"
    size="large"
    :activeState="isSatelliteActive ? 'active' : 'inactive'"
    @clicked="onClick"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'
import iconSatellite from '@/assets/icon-satellite.svg'
import { MAPVIEW_PREFIX } from '@/store/module-prefixes'
import { SET_IS_SATELLITE_ACTIVE } from '@/store/mutation-types'

const store = useStore()
const isSatelliteActive = computed(() => store.state[MAPVIEW_PREFIX].isSatelliteActive)

function onClick() {
  store.commit(`${MAPVIEW_PREFIX}/${SET_IS_SATELLITE_ACTIVE}`, { value: !isSatelliteActive.value })
}
</script>
